import { Theme } from '@ublend-npm/aulaui-core';

export const createStyles = (theme: Theme) => {
  const isDark = theme?.palette?.mode === 'dark';

  return {
    card: {
      cursor: 'pointer',
      '&:hover .pinnedPostReadMore, &:focus-visible .pinnedPostReadMore': {
        visibility: 'visible',
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: '-2px',
      },
      py: '16px',
      borderBottom: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
    },
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: { xs: 1, sm: 1.5 },
      minWidth: 0,
      px: 2,
      pt: 2,
      pb: 1.5,
    },
    author: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      minWidth: 0,
      gap: { xs: 1, sm: 1.5 },
    },
    avatar: {
      flexShrink: 0,
      width: 40,
      height: 40,
    },
    authorDetails: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minWidth: 0,
    },
    authorNameRow: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      gap: 0.75,
    },
    authorName: {
      overflow: 'hidden',
      minWidth: 0,
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      fontWeight: theme.typography.fontWeightMedium ?? 500,
      fontStyle: 'normal',
      lineHeight: 1.5,
      letterSpacing: '0.15px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    roleBadge: {
      backgroundColor: isDark ? '#B4E8FB' : '#007D99',
      color: isDark ? '#005B6C' : '#FFFFFF',
      cursor: 'default',
      fontSize: '13px',
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    readMore: {
      visibility: 'hidden',
      fontSize: '13px',
      fontWeight: 500,
      color: theme.palette.primary.main,
      px: '5px',
      py: '4px',
      gap: '8px',
      backgroundColor: isDark ? '#D0BCFA14' : '#4521880A',
      boxShadow: 'none',
      borderRadius: '4px',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: isDark ? '#D0BCFA14' : '#4521880A',
      },
    },
    stats: {
      display: 'flex',
      alignItems: 'center',
      gap: '24px',
    },
    stat: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.secondary,
      gap: '4px',
    },
    statIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: isDark ? '#FFFFFF8F' : '#231F298F',
    },
    statValue: {
      color: isDark ? '#FFFFFFB2' : '#00000099',
      fontWeight: '500',
    },
    timestamp: {
      overflow: 'hidden',
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: '12px',
      lineHeight: 1.66,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  };
};
